import { render } from "./ConversationMessageItem.vue?vue&type=template&id=702c376a&scoped=true"
import script from "./ConversationMessageItem.vue?vue&type=script&lang=js"
export * from "./ConversationMessageItem.vue?vue&type=script&lang=js"

import "./ConversationMessageItem.vue?vue&type=style&index=0&id=702c376a&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/jalizan/webapp/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-702c376a"]])

export default __exports__